<section class="sps-signal-detail">

  <!-- KOPF -->
  <header class="kopf">
    <button mat-icon-button type="button" (click)="zurueck()" [matTooltip]="zurueckText">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="kopf-titel">
      <h1>
        <span class="titel-name">{{ signal?.name || (signal ? signal.adresseNormiert : '') || 'SPS-Signal' }}</span>
        <span class="status-badge titel-status" *ngIf="signal" [ngClass]="option(signal.pruefstatus).klasse">
          <mat-icon inline>{{ option(signal.pruefstatus).icon }}</mat-icon>
          {{ option(signal.pruefstatus).text }}
        </span>
      </h1>
      <app-sps-breadcrumbs [teile]="[
        { text: 'Projekt', route: ['/projekte', projektId], icon: 'folder' },
        { text: 'SPS-Prüfung', route: ['/projekte', projektId, 'sps-pruefung'], query: filterParamsFuerLink },
        { text: signal?.name || 'Signal' }
      ]"></app-sps-breadcrumbs>
    </div>

    <!-- VORHERIGES / NÄCHSTES in der Auswahl der SPS-Prüfung -->
    <div class="kopf-navigation" *ngIf="nachbarn">
      <button mat-stroked-button type="button" (click)="vorheriges()" [disabled]="!hatVorheriges || laedt" matTooltip="Vorheriges Signal (gleiche Filterung und Sortierung)">
        <mat-icon>chevron_left</mat-icon>
        Vorheriges
      </button>

      <span class="position" *ngIf="positionText">{{ positionText }}</span>

      <button mat-stroked-button type="button" (click)="naechstes()" [disabled]="!hatNaechstes || laedt" matTooltip="Nächstes Signal (gleiche Filterung und Sortierung)">
        Nächstes
        <mat-icon iconPositionEnd>chevron_right</mat-icon>
      </button>
    </div>

    <div class="kopf-aktionen">
      <button mat-stroked-button type="button" (click)="laden()" [disabled]="laedt">
        <mat-icon>refresh</mat-icon>
        Aktualisieren
      </button>

      <button mat-stroked-button color="warn" type="button" *ngIf="canEdit && signal" (click)="signalLoeschen()"
        [disabled]="loescht || speichert" matTooltip="Nur aus der Prüfung entfernen oder vollständig löschen">
        <mat-icon>delete_outline</mat-icon>
        Löschen
      </button>
    </div>
  </header>

  <!-- FEHLER / LADEN -->
  <div class="fehlermeldung" *ngIf="fehler">
    <mat-icon>error_outline</mat-icon>
    <span>{{ fehler }}</span>
    <button mat-button type="button" (click)="zurPruefung()">Zur SPS-Prüfung</button>
  </div>

  <div class="laden" *ngIf="laedt && !signal">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="signal as s">

    <div class="spalten">

      <!-- LINKS: TECHNISCHE DATEN + QUELLEN -->
      <div class="spalte">

        <!-- TECHNISCHE DATEN -->
        <mat-card class="sps-card">
          <mat-card-content>
            <h2 class="karten-titel">
              <mat-icon>memory</mat-icon>
              Technische Daten
            </h2>

            <dl class="felder">
              <ng-container *ngFor="let f of technischeFelder">
                <dt>{{ f.label }}</dt>
                <dd [class.mono]="f.mono" [class.fehlt]="!f.wert">{{ f.wert || '–' }}</dd>
              </ng-container>

              <dt>Aktueller Prüfstatus</dt>
              <dd>
                <span class="status-badge" [ngClass]="option(s.pruefstatus).klasse">
                  <mat-icon inline>{{ option(s.pruefstatus).icon }}</mat-icon>
                  {{ option(s.pruefstatus).text }}
                </span>
                <span class="geprueft-von" *ngIf="s.zuletztGeprueftAmUtc">
                  {{ s.zuletztGeprueftAmUtc | date:'dd.MM.yyyy HH:mm' }}<ng-container *ngIf="s.zuletztGeprueftVon"> · {{ s.zuletztGeprueftVon }}</ng-container>
                </span>
              </dd>
            </dl>

            <p class="hinweis-zeile" *ngIf="s.hatUngeklaerteZuordnung">
              <mat-icon inline class="warn">help_outline</mat-icon>
              Mindestens eine Quelle dieses Signals ist noch nicht eindeutig zugeordnet (siehe Datenquellen).
            </p>

            <p class="hinweis-zeile" *ngIf="s.geaendertSeitPruefungAmUtc">
              <mat-icon inline class="warn">update</mat-icon>
              <strong>Seit Prüfung geändert</strong> ({{ s.geaendertSeitPruefungAmUtc | date:'dd.MM.yyyy HH:mm' }}):
              ein Listenupdate hat prüfrelevante Angaben verändert; der Prüfstatus wurde nicht zurückgesetzt.
              <ng-container *ngIf="s.geaendertSeitPruefungHinweis"> {{ s.geaendertSeitPruefungHinweis }}</ng-container>
              Eine erneute Prüfung entfernt die Kennzeichnung.
            </p>
          </mat-card-content>
        </mat-card>

        <!-- DATENQUELLEN -->
        <mat-card class="sps-card">
          <mat-card-content>
            <h2 class="karten-titel">
              <mat-icon>layers</mat-icon>
              Datenquellen
              <span class="karten-anzahl">{{ s.quellen.length }}</span>
            </h2>

            <p class="karten-text">
              Aus diesen importierten Listen stammt das Signal. Die Originalzeilen bleiben unverändert erhalten;
              geprüft wird das gemeinsame Signal genau einmal.
            </p>

            <p class="leer" *ngIf="s.quellen.length === 0">
              Keine Quelle mehr vorhanden – die zugehörige Liste wurde gelöscht. Der Prüfverlauf bleibt archiviert.
            </p>

            <div class="quelle" *ngFor="let q of s.quellen; let i = index; trackBy: trackByQuelle" [class.quelle-ungeklaert]="q.status === 'Ungeklaert'">
              <div class="quelle-kopf">
                <mat-icon>{{ listeIcon(q) }}</mat-icon>
                <div class="quelle-titel">
                  <span class="quelle-nr">Quelle {{ i + 1 }}: {{ listeTitel(q) }}</span>
                  <a href="javascript:void(0)" class="quelle-liste" (click)="oeffneListe(q.listeId)" [matTooltip]="'Liste „' + q.listeName + '“ öffnen'">
                    {{ q.listeName }} · Zeile {{ q.excelZeile }}
                  </a>
                </div>
                <span class="quelle-status" [class.ungeklaert]="q.status === 'Ungeklaert'" [matTooltip]="q.zuordnungsGrund || ''">
                  {{ q.status === 'Ungeklaert' ? 'Zuordnung ungeklärt' : 'Zugeordnet' }}
                </span>
              </div>

              <dl class="felder felder-kompakt">
                <ng-container *ngFor="let f of quellenFelder(q)">
                  <dt>{{ f.label }}</dt>
                  <dd [class.mono]="f.mono" [class.fehlt]="!f.wert">{{ f.wert || '–' }}</dd>
                </ng-container>
              </dl>
            </div>

            
            
          </mat-card-content>
        </mat-card>

      </div>

      <!-- RECHTS: PRÜFUNG + VERLAUF -->
      <div class="spalte">

        <!-- PRÜFUNG -->
        <mat-card class="sps-card pruefung-card">
          <mat-card-content>
            <h2 class="karten-titel">
              <mat-icon>fact_check</mat-icon>
              Prüfung
            </h2>

            <!-- Versionskonflikt -->
            <div class="konflikt" *ngIf="versionskonflikt">
              <mat-icon>sync_problem</mat-icon>
              <div>
                <strong>Das Signal wurde zwischenzeitlich geändert.</strong>
                <span>{{ speicherFehler }}</span>
              </div>
              <button mat-stroked-button type="button" (click)="laden()">Neu laden</button>
            </div>

            <div class="fehlermeldung klein" *ngIf="speicherFehler && !versionskonflikt">
              <mat-icon>error_outline</mat-icon>
              <span>{{ speicherFehler }}</span>
            </div>

            <p class="nur-lesen" *ngIf="!canEdit">
              <mat-icon inline>lock</mat-icon>
              Nur Leserecht – der Prüfstatus kann hier nicht geändert werden.
            </p>

            <!-- Statusauswahl -->
            <div class="status-auswahl" role="radiogroup" aria-label="Prüfstatus">
              <button type="button" role="radio" *ngFor="let o of statusOptionen" class="status-option" [ngClass]="o.klasse"
                [class.gewaehlt]="entwurfStatus === o.wert" [attr.aria-checked]="entwurfStatus === o.wert"
                [disabled]="!canEdit || speichert || versionskonflikt" (click)="statusWaehlen(o.wert)">
                <mat-icon>{{ o.icon }}</mat-icon>
                <span>{{ o.text }}</span>
              </button>
            </div>

            <!-- Bemerkung -->
            <mat-form-field appearance="outline" class="bemerkung-feld">
              <mat-label>{{ bemerkungPflicht ? 'Fehlerbeschreibung (Pflicht bei „Nicht OK“)' : 'Bemerkung' }}</mat-label>
              <textarea matInput [(ngModel)]="entwurfBemerkung" rows="4" maxlength="4000"
                [disabled]="!canEdit || speichert || versionskonflikt"
                placeholder="z. B. Signal schaltet beim Betätigen des Tasters nicht."></textarea>
              <mat-hint align="end">{{ entwurfBemerkung.length }} / 4000</mat-hint>
              <mat-error *ngIf="bemerkungFehlt">Bei „Nicht OK“ ist eine Fehlerbeschreibung erforderlich.</mat-error>
            </mat-form-field>

            <p class="pflicht-hinweis" *ngIf="bemerkungFehlt">
              <mat-icon inline>info</mat-icon>
              Bei „Nicht OK“ ist eine Fehlerbeschreibung erforderlich.
            </p>

            <p class="gespeichert" *ngIf="gespeichertHinweis && !geaendert">
              <mat-icon inline>check_circle</mat-icon>
              {{ gespeichertHinweis }}
            </p>

            <div class="pruefung-aktionen" *ngIf="canEdit">
              <button mat-button type="button" (click)="verwerfen()" [disabled]="!geaendert || speichert">
                Verwerfen
              </button>

              <button mat-raised-button color="primary" type="button" (click)="speichern()" [disabled]="!kannSpeichern">
                <mat-spinner diameter="18" *ngIf="speichert"></mat-spinner>
                <mat-icon *ngIf="!speichert">save</mat-icon>
                Speichern
              </button>

              <button mat-stroked-button color="primary" type="button" *ngIf="hatNaechstes" (click)="speichern(true)" [disabled]="!kannSpeichern"
                matTooltip="Speichern und zum nächsten Signal der Auswahl wechseln">
                Speichern &amp; nächstes
                <mat-icon iconPositionEnd>chevron_right</mat-icon>
              </button>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- PRÜFVERLAUF -->
        <mat-card class="sps-card">
          <mat-card-content>
            <h2 class="karten-titel">
              <mat-icon>history</mat-icon>
              Prüfverlauf
              <span class="karten-anzahl">{{ verlauf.length }}</span>
            </h2>

            <mat-progress-bar mode="indeterminate" *ngIf="laedtVerlauf"></mat-progress-bar>

            <p class="leer" *ngIf="!laedtVerlauf && verlauf.length === 0">
              Noch keine Prüfung protokolliert.
            </p>

            <ol class="verlauf" *ngIf="verlauf.length > 0">
              <li *ngFor="let p of verlauf; trackBy: trackByProtokoll" class="verlauf-eintrag">
                <div class="verlauf-kopf">
                  <span class="verlauf-zeit">{{ p.geprueftAmUtc | date:'dd.MM.yyyy HH:mm' }}</span>
                  <span class="verlauf-benutzer" *ngIf="p.geprueftVon">
                    <mat-icon inline>person</mat-icon>{{ p.geprueftVon }}
                  </span>
                </div>

                <div class="verlauf-status">
                  <span class="status-badge klein" [ngClass]="option(p.alterStatus).klasse">{{ option(p.alterStatus).text }}</span>
                  <mat-icon inline class="pfeil">arrow_forward</mat-icon>
                  <span class="status-badge klein" [ngClass]="option(p.neuerStatus).klasse">{{ option(p.neuerStatus).text }}</span>
                  <span class="verlauf-art" *ngIf="p.alterStatus === p.neuerStatus">Bemerkung bzw. Zusammenführung</span>
                </div>

                <p class="verlauf-bemerkung" *ngIf="p.bemerkung">{{ p.bemerkung }}</p>
              </li>
            </ol>
          </mat-card-content>
        </mat-card>

      </div>
    </div>

  </ng-container>

</section>
